<template>
  <div class="single-image">
    <div class="section-header">
      <h3>{{ title }}</h3>
    </div>
    <div class="image-wrapper">
      <img v-if="images.length" :src="images[0]" class="image" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SingleImage',
  props: {
    title: {
      type: String,
      default: ''
    },
    images: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.single-image {
  height: 100%;
  background: rgba(26, 54, 93, 0.6);
  border-radius: 12px;
  padding: 16px;
  border: 1px solid rgba(99, 179, 237, 0.2);
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(99, 179, 237, 0.2);
  flex-shrink: 0;
}

h3 {
  font-size: 14px;
  font-weight: 600;
  color: #e2e8f0;
  margin: 0;
}

.image-wrapper {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 6px;
  display: block;
}

.image-alt {
  font-size: 12px;
  color: #a0aec0;
  margin-top: 6px;
  text-align: center;
}
</style>
